exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 400px) {    \n    \n            .g-recaptcha {\n              transform:scale(0.80) !important;\n              -webkit-transform:scale(0.80) !important;\n              transform-origin:0 0 !important;\n              -webkit-transform-origin:0 0 !important;\n            }\n          }\n\n@media (max-width: 520px) {  \n    .iCondiciones{\n        padding: 30px !important;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/auth/register-user/register-user.component.css
// module id = ../../../../../src/app/auth/register-user/register-user.component.css
// module chunks = main